// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"a9621693","226":"08752380","453":"99a84de1"}[chunkId] + ".chunk.js";
};